import React from 'react';
import './fullWindowSpinner.css'; // CSS file for styling the spinner

const FullWindowSpinner = () => {
    return (
        <div className="full-window-spinner">
            <div className="spinner"></div>
        </div>
    );
};

export default FullWindowSpinner;